module.exports = __webpack_public_path__ + "img/thumbnail_StripedHyena_j_normal.484a0a3f.png";